import Axios from "axios";
import { getEnvVar } from "ideas.env";
import { getRequestHeaders } from "utils/getRequestHeaders";

export const getMarketingConsent = async () => {
  const headers = await getRequestHeaders();
  const response = await Axios.get<{ email_marketing_consent: boolean }>(
    getEnvVar("URL_MARKETING_CONSENT"),
    {
      headers,
    },
  );
  return response.data.email_marketing_consent;
};

export const setMarketingConsent = async (consent: boolean) => {
  const headers = await getRequestHeaders();
  const response = await Axios.post<{ email_marketing_consent: boolean }>(
    getEnvVar("URL_MARKETING_CONSENT"),
    {
      email_marketing_consent: consent,
    },
    {
      headers,
    },
  );
  return response.data.email_marketing_consent;
};
